/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { FC, useContext, useEffect, useState } from 'react'

import { Col, Row, Spin } from 'antd'
import ID_COMPONENTE from 'config/idComponente'
import { ApplicationContext } from 'Context'
import usuarios from 'Helpers/usuarios'
import { CLAIMS } from 'Hooks/usePermissions/constants.claims'
import { IPerfil, IPermissao, UsuarioAtual } from 'Models/auth'
import moment from 'moment'
import env from 'react-dotenv'
import { Routes, Route, useNavigate } from 'react-router-dom'
import { authentication } from 'Routes'
import handleToken from 'Services/handleToken'
import AuthService from 'Services/UAA'
import autenticacao from 'Services/WS_DOCAS/autenticacao'
import ChangePassword from 'Views/Auth/ChangePassword'
import Login from 'Views/Auth/Login'
import RecoverPassword from 'Views/Auth/RecoverPassword'

//import 'antd/dist/antd.dark.css';
import { LayoutBackground, Container, ColLeft, ColRight } from './styles'

const AuthLayout: FC = () => {
  const [modoDebug] = useState<boolean>(env.MODO_DEBUG === 'true')
  const [mensagemErro, setMensagemErro] = useState<string>()
  const navigate = useNavigate()

  const { applicationContext, setApplicationContext } =
    useContext(ApplicationContext)

  const carregaPortalDocas = async (
    currentURL: string,
    pagina: string,
    cdArmazemPreSelecionado?: number,
    nomeArmazemPreSelecionado?: string,
    dataPreSelecionada?: string,
  ) => {
    try {
      const { data } = await autenticacao.buscaDados(ID_COMPONENTE.DOCAS)

      if (data?.token) {
        handleToken.setToken(data.token)

        let tempoSessaoMs: number | undefined
        let dataInicioSessao: Date | undefined

        if (
          currentURL.includes('tempoSessaoMinutos=') &&
          currentURL.includes('dataInicioSessao=')
        ) {
          let tempoSessao: string = currentURL.split('tempoSessaoMinutos=')[1]
          tempoSessao = tempoSessao.substring(0, tempoSessao.indexOf('&'))
          tempoSessaoMs = window.parseInt(tempoSessao) * 60000 //Conversão para milissegundos

          let inicioSessao: string = currentURL.split('dataInicioSessao=')[1]
          inicioSessao = inicioSessao.substring(0, inicioSessao.indexOf('&'))
          inicioSessao = inicioSessao.replaceAll('%20', ' ') //Às vezes o espaço na URL é interpretado como %20
          dataInicioSessao = new Date(inicioSessao)

          window.sessionStorage.setItem(
            'tempoSessaoMs',
            tempoSessaoMs.toString(),
          )
          window.sessionStorage.setItem('dataInicioSessao', inicioSessao)
        }

        const usuario: UsuarioAtual = {
          perfis: data.autenticacao.perfis,
          cdsTransportadoras: data.cdsTransportadoras,
          cdEntidade: data.autenticacao.entidade.cdEntidade,
          cdEntidadeSistema: data.autenticacao.entidade.cdEntidadeSistema,
          cdUsuario: data.autenticacao.cdUsuario,
          nome: data.autenticacao.nome,
          login: data.autenticacao.login,
          permissoes: verificaPermissoes(data.autenticacao.perfis),
          mestreSistema: data.autenticacao.mestreSistema,
        }

        usuario.cdsTransportadoras =
          usuarios.verificaTransportadorasUsuario(usuario)

        setApplicationContext({
          ...applicationContext,
          usuarioAtual: usuario,
          cdArmazemPreSelecionado: cdArmazemPreSelecionado,
          nomeArmazemPreSelecionado: nomeArmazemPreSelecionado,
          dataPreSelecionada: dataPreSelecionada,
          textoDocumentoViagem:
            data.autenticacao.entidade.cdEntidadeSistema === 299 //Adami
              ? 'Plano de Viagem'
              : 'Documento da Viagem',
          tempoSessaoMs: tempoSessaoMs,
          dataInicioSessao: dataInicioSessao,
        })

        navigate(pagina)
      }
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e: any) {
      const mensagemErro =
        'Verifique se você está logado em outro navegador ou computador. Se sim, por gentileza refaça o login, pois só é permitida uma sessão de cada vez'

      setMensagemErro(mensagemErro)
      if (modoDebug) {
        window.alert(mensagemErro)
      }

      console.error(e)
    }
  }

  const verificaPermissoes = (perfis: IPerfil[]) => {
    const permissoes: IPermissao[] = perfis[0].permissoes

    for (let iPerfil = 1; iPerfil < perfis.length; iPerfil++) {
      const perfil: IPerfil = perfis[iPerfil]

      for (
        let iPermissao = 0;
        iPermissao < perfil.permissoes.length;
        iPermissao++
      ) {
        const permissaoPerfil: IPermissao = perfil.permissoes[iPermissao]

        if (
          !permissoes.some((permissao) => permissao.id === permissaoPerfil.id)
        ) {
          permissoes.push(permissaoPerfil)
        }
      }
    }

    return permissoes
  }

  useEffect(() => {
    const currentURL: string = window.location.href

    if (currentURL.includes('at=')) {
      const autorizacao: string = currentURL.split('at=')?.[1]

      if (autorizacao) {
        handleToken.setToken(autorizacao)

        const pagina = currentURL.includes('iranifob')
          ? '/DocasIraniFob'
          : '/Docas'

        if (
          currentURL.includes('nomeArmazem=') &&
          currentURL.includes('data=')
        ) {
          let cdArmazem: number | undefined

          if (currentURL.includes('cdArmazem=')) {
            const cdArmazemString: string = currentURL.split('cdArmazem=')?.[1]
            cdArmazem = window.parseInt(
              cdArmazemString.substring(0, cdArmazemString.indexOf('&')),
            )
          }

          let nomeArmazem: string = currentURL.split('nomeArmazem=')?.[1]
          nomeArmazem = nomeArmazem.substring(0, nomeArmazem.indexOf('&'))
          nomeArmazem = nomeArmazem.replaceAll('%20', ' ') //O espaço na URL é interpretado como %20

          let dataArmazem: string = currentURL.split('data=')?.[1]
          dataArmazem = dataArmazem.substring(0, dataArmazem.indexOf('&'))

          carregaPortalDocas(
            currentURL,
            pagina,
            cdArmazem,
            nomeArmazem,
            dataArmazem,
          )
        } else {
          carregaPortalDocas(currentURL, pagina)
        }
      }
    }
  }, [])

  return modoDebug ? (
    <>
      <div style={{ textAlign: 'center', fontSize: '24px' }}>
        IMPORTANTE: Essa tela só aparece se o modo debug estiver ativado no
        arquivo de configuração do servidor
      </div>
      <LayoutBackground id="layout-auth" justify="center" align="middle">
        <Container id="layout-auth-container">
          <Row>
            <ColLeft span={12} id="layout-auth-container-box-left" />
            <ColRight span={12} id="layout-auth-container-box-right">
              <Routes>
                <Route path="/" element={<Login />} />
                <Route
                  path={authentication.recoveryPassword}
                  element={<RecoverPassword />}
                />
                <Route
                  path={authentication.changePassword}
                  element={<ChangePassword />}
                />
              </Routes>
            </ColRight>
          </Row>
        </Container>
      </LayoutBackground>
    </>
  ) : (
    <Col style={{ height: '100vh', width: '100%' }}>
      <Row
        align="middle"
        justify="center"
        style={{ height: '100vh', width: '100%' }}
      >
        <Spin size="large" />
        <div
          style={{
            fontSize: '20px',
            fontWeight: 600,
            marginTop: '-8px',
            marginLeft: '15px',
          }}
        >
          {mensagemErro ? mensagemErro : 'Carregando...'}
        </div>
      </Row>
    </Col>
  )
}

export default AuthLayout
